import { apiPut } from '../generic/Api_Functions'
import SmartMateriaUITable from '../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

/**
 *
 * @param {Object} props
 * @param {Function} props.setSelectedDeliveryNote
 * @param {JSX.Element} props.alertElement
 * @returns
 */
const DeliveryNoteSelector = ({ setSelectedDeliveryNote, alertElement }) => {
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      name: t_('Record code'),
      field: 'recordCode'
    },
    {
      name: t_('Delivery note number'),
      field: 'number'
    },
    {
      name: t_('Date'),
      field: 'date',
      type: 'dateTimePicker'
    },
    {
      name: t_('Supplier code'),
      field: 'supplier.code'
    },
    {
      name: t_('Supplier name'),
      field: 'supplier.name'
    }
  ]

  const dataFetch = async (pagination) => {
    const data = await apiPut('deliveryNote/getAll', pagination)
    return data
  }

  return (
    <>
      {alertElement}
      <SmartMateriaUITable
        columns={columns}
        dataFetch={dataFetch}
        pageable
        onRowClick={(row) => {
          if (setSelectedDeliveryNote && typeof setSelectedDeliveryNote === 'function' && row.id) {
            setSelectedDeliveryNote(row)
          }
        }}
      />
    </>
  )
}

export default DeliveryNoteSelector
